import { render, staticRenderFns } from "./OwnerSelect.vue?vue&type=template&id=4130aac8&"
import script from "./OwnerSelect.vue?vue&type=script&lang=js&"
export * from "./OwnerSelect.vue?vue&type=script&lang=js&"
import style0 from "./OwnerSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports